import { render, staticRenderFns } from "./ServicesDifferenceWarning.vue?vue&type=template&id=78263315&"
import script from "./ServicesDifferenceWarning.vue?vue&type=script&lang=js&"
export * from "./ServicesDifferenceWarning.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports